export default "__VITE_ASSET__2fda018d__"